import { orchestrator } from "satcheljs";
import { updateCopilotChatDrawerPinnedPaneAction, type UpdateCopilotChatDrawerPinnedPaneMessage, } from "owa-copilot-chat-drawer-store";
import { PinnablePane } from "owa-outlook-service-option-store";
import { savePinnedPaneSetting } from "../utils/savePinnedPaneSetting";
import { isPanePinningEnabled } from "../utils/isPanePinningEnabled";
import { getCurrentPinnablePane } from "../utils/getPinnablePaneRegistrations";

/**
 * Orchestrator to handle saving and removing the Copilot Chat Drawer as a pinned pane setting.
 * Will call savePinnedPaneSetting, with either the appropriate new PinnablePane or just 'None'
 * if there is no pane to save as the new pinned pane.
 */
orchestrator(updateCopilotChatDrawerPinnedPaneAction, (actionMessage: UpdateCopilotChatDrawerPinnedPaneMessage) => {
    if (!isPanePinningEnabled()) {
        return;
    }
    
    if (actionMessage.isSavingAsCopilotChatDrawer) {
        savePinnedPaneSetting(PinnablePane.CopilotChat);
    }
    else {
        // If we're not saving as Copilot Chat Drawer, that means we're
        // closing the Drawer and need to see what to properly save as the
        // new pinned pane setting. It's either the current FlexPane if the
        // FlexPane is pinnable, or just 'None' otherwise.
        savePinnedPaneSetting(getCurrentPinnablePane());
    }
});
